import styled from 'styled-components/macro'
import { motion } from 'framer-motion'

import MaskSocial from 'assets/mask-social.png'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'
import { Container } from 'components/container'

export const ObservedPoint = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 1rem;
  height: 5rem;
`

export const StyledNav = styled.nav`
  position: relative;
  width: 100%;
  padding-block: 1em 0;
  z-index: 1;

  > ${Container} {
    display: flex;
    align-items: center;
  }
`

export const Logo = styled.img`
  height: 3.5rem;
  width: auto;
  display: block;
  overflow: hidden;

  ${mq.medium} {
    height: 5rem;
  }
`

export const LogoContainer = styled(motion.a)`
  display: block;
  width: max-content;
  color: inherit;
  overflow: hidden;
  margin-inline-end: auto;

  &:hover,
  &:focus {
    color: inherit;
  }
`

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  right: var(--container-spacing);
  width: 1.9rem;
  height: var(--header-height);
  box-sizing: content-box;
  flex-shrink: 0;
  transition: 0.4s opacity 0.55s;
  z-index: 600;

  ${mq.medium} {
    width: auto;
  }
`

export const CloseButton = styled.li`
  margin-top: -0.1em;
  padding: 0.8rem;

  button {
    ${styleReset}
    display: block;
    position: relative;
    cursor: pointer;
    width: 1.6rem;
    height: 1.6rem;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      border-top: 2px solid white;
      transform: rotateZ(45deg);
    }

    &::after {
      transform: rotateZ(-45deg);
    }
  }

  ${mq.smallOnly} {
    button::before,
    button::after {
      border-top-color: ${theme.colors.accent.primary};
    }
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  mask: url('${MaskSocial}');
  height: 3.8rem;

  ${mq.smallOnly} {
    min-width: 18rem;
  }
`
